import { type DefaultProfileAddressContactInformationSetting } from "shared/helpers/profile/address/defaultAddressFromProfile";
import { type SocietyView } from "shared/mappers/database/society/society";

export const getDefaultAddressContactInformationPublicSetting = ({
  society,
}: {
  society: SocietyView | undefined;
}): DefaultProfileAddressContactInformationSetting => {
  if (!society) {
    return {};
  }
  const defaultProfileAddressContactInformationSetting =
    society.societySettingsPublic?.defaultProfileAddressContactInformation;

  return defaultProfileAddressContactInformationSetting ?? {};
};
